import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { SET_THE_REALM } from '../app/start/actions';

const RealmSync = ({ theRealm, setTheRealm }) => {
    const { realm } = useParams();

    useEffect(() => {
        if (realm && realm !== theRealm) {
            setTheRealm(realm);
        }
    }, [realm, theRealm, setTheRealm]);

    return null;
};

function mapStateToProps({ theRealm }) {
    return { theRealm };
}

function mapDispatchToProps(dispatch) {
    return {
        setTheRealm(theRealm) {
            dispatch({ type: SET_THE_REALM, action: theRealm });
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(RealmSync);
